import deleteIconImg from './delete.svg';
import filterIconImg from './filter.svg';
import newIconImg from './new.svg';
import refreshIconImg from './refresh.svg';
import revertIconImg from './revert.png';
import saveIconImg from './save.png';
import seamlessLoginIconImg from './seamlesslogin.png';
import clearImg from '../close.svg';
import sortImg from './sort.png';
import sortUpImg from './sortUp.png';
import filterBadgeImg from './filterBadge.svg';
import cloneImg from './clone.svg';
import changeImg from './change.svg';


export const deleteIcon = deleteIconImg;
export const filterIcon = filterIconImg;
export const newIcon = newIconImg;
export const refreshIcon = refreshIconImg;
export const revertIcon = revertIconImg;
export const saveIcon = saveIconImg;
export const seamlessLoginIcon = seamlessLoginIconImg;
export const clearIcon = clearImg;
export const sortIcon = sortImg;
export const sortUpIcon = sortUpImg;
export const filterBadgeIcon = filterBadgeImg;
export const cloneIcon = cloneImg;
export const changeIcon = changeImg;
